const hasAvatar = (user) =>
  !!(
    user.avatar &&
    typeof user.avatar === 'object' &&
    (user.avatar.id != null || user.avatar.url)
  )

// CSV import fills full_name but not a photo, so full_name can't be the signal.
export const isTradieOnboarded = (user) =>
  !!user.profile_completed || hasAvatar(user)

// avatar is left out of some responses; only an explicit null means no photo.
export const tradieNeedsNewPhoto = (user) =>
  !!user &&
  user.user_type === 'tradie' &&
  !!user.profile_completed &&
  user.avatar === null
